import TextSelector from 'components/Common/TextSelector';
import ContentSummary from 'components/Dashboard/components/ContentSummary';
import createMarkup from 'components/Dashboard/helpers/createMarkup';
import adjustPDFScale from 'components/Dashboard/utilities/adjustPDFScale';
import React, { useEffect, useRef } from 'react';
import time from 'utils/time';

const RegulationsDocumentOverviewTab = ({ currentNew, scrolling, scrollbarRef: scrollbarRefProp }) => {
  const internalScrollbarRef = useRef(null);
  const scrollbarRef = scrollbarRefProp ?? internalScrollbarRef;
  const documentContentContainerRef = useRef(null);
  const hasAdjustedPDFScale = useRef(false);

  useEffect(() => {
    const container = documentContentContainerRef.current;
    if (container && !hasAdjustedPDFScale.current) {
      adjustPDFScale(container);
      hasAdjustedPDFScale.current = true;
    }
  }, []);

  return (
    <>
      <ContentSummary content={currentNew} />
      <div className='border-bottom px-3 px-lg-4 pb-3 pb-lg-4'>
        {currentNew?.govDocumentId && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Document ID</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
              {currentNew?.govDocumentId}
            </span>
          </div>
        )}
        {currentNew?.documentType && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Document Type</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
              {currentNew?.documentType}
            </span>
          </div>
        )}

        {currentNew?.agency && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Agency</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>{currentNew?.agency}</span>
          </div>
        )}
        {currentNew?.docketType && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Docket Type</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
              {currentNew?.docketType}
            </span>
          </div>
        )}
        {currentNew?.docketTitle && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Docket title</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
              {currentNew?.docketTitle}
            </span>
          </div>
        )}
        {currentNew?.rin && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>RIN</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>{currentNew?.rin}</span>
          </div>
        )}
        {currentNew?.postedDate && (
          <div className='d-flex align-items-center mb-2'>
            <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Posted date</span>
            <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
              {time(currentNew?.postedDate).formatGeneralDate()}
            </span>
          </div>
        )}
        <div className='d-flex align-items-center mb-2'>
          <span className='d-inline-block flex-grow-1 col-4 paragraph-p1 text-main-blue-65 px-0'>Source URL</span>
          <span className='d-inline-block flex-grow-1 col-12 paragraph-p1 text-main-blue'>
            <a
              href={currentNew?.sourceUrl}
              className='text-light-blue link-hover'
              target='_blank'
              rel='noopener noreferrer'
            >
              {currentNew?.sourceUrl}
            </a>
          </span>
        </div>
      </div>
      <div className='px-3 px-lg-4 pb-3 pb-lg-4'>
        <TextSelector currentNew={currentNew} scrollbarRef={scrollbarRef} scrolling={scrolling}>
          <div className='pt-3 news-content-in parliamentary-content-in context committee-publication-content'>
            {currentNew.body && (
              <div className='debate-item-contributiondebateitem'>
                <div
                  className='explanatory-container'
                  dangerouslySetInnerHTML={createMarkup(currentNew.body)}
                  ref={documentContentContainerRef}
                />
              </div>
            )}
          </div>
        </TextSelector>
      </div>
    </>
  );
};

export default RegulationsDocumentOverviewTab;
